import { IcoMinusSmall16, IcoPlusSmall16 } from '@onefootprint/icons';

type SubcategoryToggleProps = {
  subCategoryName: string;
  onClick: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  isActive: boolean;
  tabIndex?: number;
};

const SubcategoryToggle = ({ subCategoryName, onClick, onKeyDown, isActive, tabIndex = 0 }: SubcategoryToggleProps) => {
  return (
    <button
      type="button"
      className="flex items-center gap-2 p-1 px-2 rounded group hover:bg-hover"
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
      aria-expanded={isActive}
      aria-label={`${subCategoryName} toggle`}
    >
      {isActive ? <IcoMinusSmall16 color="secondary" /> : <IcoPlusSmall16 color="secondary" />}
      <h3 className="text-label-2">{subCategoryName}</h3>
    </button>
  );
};

export default SubcategoryToggle;
